import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addBrandType } from '../../redux/actions';

import { DetailsItem } from '../Details/Details';
import { TextField, Button, Autocomplete } from '@mui/material';

import {
	Add,
	Check,
} from '@mui/icons-material';

function BrandTypeInput(props) {
	const {
		id,
		brand,
		serial: type,
		part_code,
	} = props.part;

	const store = useSelector(state => state.store);
	const { t } = store;
	const dispatch = useDispatch();

	const [partData, setPartData] = useState([]);

	const [brandValue, setBrandValue] = useState(brand);
	const [typeValue, setTypeValue] = useState(type);

	const [isDisabled, setIsDisabled] = useState(true);
	const [isClicked, setIsClicked] = useState(false);

	const [selectedBrand, setSelectedBrand] = useState(brand);
	const [selectedType, setSelectedType] = useState(type);
	const [selectedBrandData, setSelectedBrandData] = useState([]);
	const [typeOptions, setTypeOptions] = useState([]);

	useEffect(() => {
		setTypeOptions(selectedBrandData.map(i => i.serials).flat() || []);
	}, [selectedBrandData, partData]);

	useEffect(() => {
		// Equals loosely, because both sides of the comparison may be either
		// a String or a Number
		setPartData(store.brands.filter(option => option.id == part_code)); // eslint-disable-line eqeqeq
	}, [store, part_code]);

	useEffect(() => {
		setSelectedBrandData(partData.filter(item => item.brand === selectedBrand) || []);
	}, [partData, selectedBrand]);

	function validateValue(value) {
		return value.trim();
	}

	function handleClick () {
		dispatch(addBrandType({
			part_type_fk_part_id: id,
			part_type_brand: selectedBrand,
			part_type_serial_number: selectedType,
		}));
		setIsClicked(true);
		setTimeout(() => { setIsClicked(false); }, 2000);
	}

	function onBrandChange(event, value) {
		value = validateValue(value);
		if (event) { // ie. not onBlur
			setBrandValue(value);
			setSelectedBrand(value);
			setTypeValue('');
		}
	}

	function onTypeChange(event, value) {
		value = validateValue(value);
		setTypeValue(value);
		setSelectedType(value);
	}

	function onBrandInputChange(event, value) {
		value = validateValue(value);
		if (event) { // ie. not onBlur
			setBrandValue(value);
			setSelectedBrand(value);
			setTypeValue('');
		}
	}

	function onTypeInputChange(event, value) {
		value = validateValue(value);
		setSelectedType(value);
		setIsDisabled(true);
		setTypeValue(value);

		// Hack; if it’s INPUT we know the user typed, if it's LI or BUTTON
		// they clicked, in which case they are using prefilled options which
		// should disable the 'add to options' button
		if (event && event.currentTarget.tagName === 'INPUT') {
			setIsDisabled(false);
		}
	}

	return (
		<div className="grid-inline grid-inline-start grid-block-portrait">
			<DetailsItem
				noMargin>
				<div className="spacing-default-right">
					<Autocomplete
						id={`${part_code}_brand`}
						className="spacing-default-right"
						options={ sortAZ(partData.map(({ brand }) => brand)) }
						style={{ width: 200 }}
						value={ brandValue }
						clearOnBlur={ false }
						onChange={ onBrandChange }
						onInputChange={ onBrandInputChange }
						isOptionEqualToValue={ (option, value) => option.id === value.id }
						renderInput={(params) => (
							<TextField
								placeholder={ t.brand }
								variant="standard"
								{...params}
							/>
						)}
					/>
				</div>
			</DetailsItem>

			<DetailsItem
				noMargin>
				<div
					className="spacing-default-right">
					<Autocomplete
						id={`${part_code}_serial`}
						className="spacing-default-right"
						options={ sortAZ(typeOptions) }
						style={{ width: 200 }}
						value={ typeValue }
						clearOnBlur={ false }
						onChange={ onTypeChange }
						onInputChange={ onTypeInputChange }
						isOptionEqualToValue={ (option, value) => option.id === value.id }
						disabled={ !selectedBrand }
						renderInput={(params) => (
							<TextField
								placeholder={ t.type }
								variant="standard"
								{...params}
							/>
						)}
					/>
				</div>
			</DetailsItem>

			<DetailsItem
				noMargin>
				<Button
					onClick={handleClick}
					disabled={isDisabled}
					variant={ isClicked ? 'contained' : 'outlined' }
					color={ isClicked ? 'success' : 'primary' }
				>
					{ isClicked &&
						<Check />
					}
					{ !isClicked &&
						<Add />
					}
				</Button>
			</DetailsItem>
		</div>
	);

	function sortAZ(array) {
		return array.sort((a, b) => a.localeCompare(b));
	}
}


export default BrandTypeInput;
